const Json2csvParser = require('json2csv').Parser

export default function exportCsv (data, fields, fileName) {
  try {
    const parser = new Json2csvParser({fields, delimiter: ';'})
    const csv = parser.parse(data)

    var csvContent = 'data:text/csvcharset=GBK,\uFEFF' + csv
    var encodedUri = encodeURI(csvContent)
    var link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${(fileName || 'file')}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (err) {
    console.error(err)
  }
}



// WEBPACK FOOTER //
// ./src/components/Datatable/src/_utils/exportCsv.js